/**
 * Sistema de manejo de productos/variantes para e-commerce
 * - Inicialización de tarjetas de producto
 * - Manejo de selectores de variantes
 * - Administración de añadir al carrito
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductCards();
  document.addEventListener('click', handleGlobalClicks);
  observeDynamicContent();
});

/**
 * Maneja todos los clicks en la página relacionados con productos
 */
function handleGlobalClicks(e) {
  // 1. Manejo de apertura del selector de tallas
  if (e.target.closest('[data-action="toggle-selector"]')) {
    const button = e.target.closest('[data-action="toggle-selector"]');
    const card = button.closest('.product-card-wrapper, .card-wrapper');
    const sizeSelector = card?.querySelector('[data-selector="size"]');
    
    if (sizeSelector) {
      sizeSelector.style.display = 'block';
      button.style.display = 'none';
      
      // Agregar clase para mantener el espacio adecuado sin afectar el flow
      card.classList.add('selector-open');
      
      // Asegurar que todos los cards debajo mantengan su posición
      const cardRect = card.getBoundingClientRect();
      const cardBottom = cardRect.bottom;
      const selectorHeight = sizeSelector.offsetHeight;
      
      // Prevenir que la página "salte" al abrir el selector
      window.scrollBy(0, 0);
    }
  }
  
  // 2. Manejo del cierre del selector
  if (e.target.closest('[data-action="close-selector"]')) {
    const closeIcon = e.target.closest('[data-action="close-selector"]');
    const card = closeIcon.closest('.product-card-wrapper, .card-wrapper');
    const sizeSelector = card?.querySelector('[data-selector="size"]');
    const showSizeButton = card?.querySelector('[data-action="toggle-selector"]');
    
    if (sizeSelector && showSizeButton) {
      sizeSelector.style.display = 'none';
      showSizeButton.style.display = 'block';
      
      // Remover clase para volver al flujo normal
      card.classList.remove('selector-open');
    }
  }
  
  // 3. Manejo de la selección de variante
  const variantButton = e.target.closest('.variant-button');
  if (variantButton && !variantButton.classList.contains('unavailable')) {
    e.stopPropagation();
    updateSelectedVariant(variantButton, false);
  }
  
  // 4. Manejo del botón añadir al carrito
  const addToCartButton = e.target.closest('[data-action="add-to-cart"]');
  if (addToCartButton) {
    e.preventDefault();
    handleAddToCart(e, addToCartButton);
  }
}

/**
 * Inicializa todas las tarjetas de producto en la página
 */
function initProductCards() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const card = entry.target;
        
        // Inicializar botones de variante
        const variantButtons = card.querySelectorAll('.variant-button');
        variantButtons.forEach(button => {
          if (!button.classList.contains('unavailable')) {
            button.removeAttribute('onclick');
          }
        });
        
        // Detener observación una vez inicializado
        observer.unobserve(card);
      }
    });
  }, {
    rootMargin: '200px',
    threshold: 0.01
  });
  
  // Observar todas las tarjetas
  document.querySelectorAll('.product-card-wrapper, .card-wrapper').forEach(card => {
    observer.observe(card);
  });
}

/**
 * Observa el DOM para inicializar elementos agregados dinámicamente
 */
function observeDynamicContent() {
  const observer = new MutationObserver((mutations) => {
    let newContentAdded = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        newContentAdded = true;
      }
    });
    
    if (newContentAdded) {
      // Inicializar nuevas tarjetas
      const newCards = Array.from(document.querySelectorAll('.product-card-wrapper, .card-wrapper'))
        .filter(card => !card.dataset.observed);
      
      newCards.forEach(card => {
        card.dataset.observed = 'true';
        
        // Inicializar botones
        const variantButtons = card.querySelectorAll('.variant-button');
        variantButtons.forEach(button => {
          if (!button.classList.contains('unavailable')) {
            button.removeAttribute('onclick');
          }
        });
      });
    }
  });
  
  // Observar contenedores que podrían recibir nuevo contenido
  document.querySelectorAll('.featured-collection, .slider-component, .collection').forEach(container => {
    observer.observe(container, { 
      childList: true, 
      subtree: true, 
      attributes: false,
      characterData: false
    });
  });
}

/**
 * Actualiza la variante seleccionada
 */
function updateSelectedVariant(button, cart=false) {
  const container = cart 
    ? button.closest('.cart-recommendations-cart-item') 
    : button.closest('.product-card-wrapper, .card-wrapper');
    
  const selectedVariantId = button.dataset.variantId;
  const hiddenVariantInput = cart 
    ? container.querySelector('.cart-recommendations-form-hidden') 
    : container.querySelector('.selected-variant-id');
  
  // Actualizar input oculto con ID de variante
  if (hiddenVariantInput) {
    hiddenVariantInput.value = selectedVariantId;
  }
  
  // Actualizar estado visual de botones
  const variantButtons = container.querySelectorAll('.variant-button');
  variantButtons.forEach(btn => {
    btn.classList.toggle('selected', btn.dataset.variantId === selectedVariantId);
  });
}

/**
 * Maneja el proceso de añadir al carrito
 */
function handleAddToCart(event, button) {
  event.preventDefault();
  
  const productCard = button.closest('.product-card-wrapper, .card-wrapper');
  const selectedVariantId = productCard.querySelector('.selected-variant-id')?.value;
  
  if (!selectedVariantId) return;
  
  // Actualizar estado del botón
  button.setAttribute('disabled', true);
  button.innerHTML = '<span>Añadiendo...</span>';
  
  // Preparar datos para enviar
  const formData = {
    id: selectedVariantId,
    quantity: 1
  };
  
  // Enviar solicitud para añadir al carrito
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
  .then(response => response.json())
  .then(item => {
    // Actualizar UI después de añadir al carrito
    Promise.allSettled([
      updateCartDrawer(true),
      updateCartIconBubble()
    ]).catch(error => {
      console.error('Error after adding to cart:', error);
    });
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  })
  .finally(() => {
    // Restaurar estado del botón
    button.removeAttribute('disabled');
    button.innerHTML = '<span>AÑADIR AL CARRITO</span>';
  });
}

/**
 * Actualiza el drawer del carrito
 */
function updateCartDrawer(openDrawer = false) {
  return new Promise((resolve, reject) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      resolve();
      return;
    }
    
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        const newDrawerContent = newDocument.querySelector('.drawer__inner');
        
        if (newDrawerContent) {
          const currentDrawerContent = cartDrawer.querySelector('.drawer__inner');
          if (currentDrawerContent) {
            requestAnimationFrame(() => {
              currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
              cartDrawer.classList.toggle('is-empty', newDrawerContent.classList.contains('is-empty'));
              
              if (openDrawer) {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else {
                  cartDrawer.classList.add('animate', 'active');
                  document.body.classList.add('overflow-hidden');
                }
              }
              
              resolve();
            });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
        resolve();
      });
  });
}

/**
 * Actualiza el icono/burbuja del carrito
 */
function updateCartIconBubble() {
  return new Promise((resolve, reject) => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartIconBubble = 
          document.querySelector('#cart-icon-bubble') || 
          document.querySelector('.cart-icon-bubble') ||
          document.querySelector('[data-cart-icon-bubble]');
        
        if (cartIconBubble) {
          const itemCount = cart.item_count;
          
          const counterElement = 
            cartIconBubble.querySelector('.cart-count-bubble span') || 
            cartIconBubble.querySelector('.cart-count');
          
          requestAnimationFrame(() => {
            if (counterElement) {
              counterElement.textContent = itemCount;
              const bubbleContainer = counterElement.closest('.cart-count-bubble') || counterElement.parentElement;
              if (bubbleContainer) {
                bubbleContainer.classList.toggle('hide', itemCount === 0);
              }
            } else {
              const newCounterElement = document.createElement('div');
              newCounterElement.className = 'cart-count-bubble';
              newCounterElement.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} artículo(s)</span>`;
              cartIconBubble.appendChild(newCounterElement);
            }
            
            resolve();
          });
        } else {
          resolve();
        }
      })
      .catch(error => {
        console.error('Error updating cart icon bubble:', error);
        resolve();
      });
  });
}